var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.device
        ? _c("div", { staticClass: "small" }, [
            _vm.device?.location &&
            (_vm.device?.location?.city || _vm.device?.location?.region)
              ? _c("div", { staticClass: "d-flex align-items-center" }, [
                  _vm._v("\n      Location:\n      "),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      staticClass: "ml-2",
                      attrs: { title: "Show Map" },
                      on: { click: _vm.showLocationModal },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.device.location.city) +
                          ", " +
                          _vm._s(_vm.device.location.region) +
                          "\n      "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm.device?.referrer
              ? _c("div", { staticClass: "overflow-hidden" }, [
                  _vm._v("\n      Referrer:"),
                  _c(
                    "a",
                    {
                      directives: [
                        { name: "b-tooltip", rawName: "v-b-tooltip" },
                      ],
                      staticClass: "text-truncate ml-2",
                      attrs: {
                        href: _vm.device?.referrer,
                        title: _vm.device?.referrer,
                        target: "_blank",
                      },
                    },
                    [_vm._v(_vm._s(_vm.referrerDomain))]
                  ),
                ])
              : _vm._e(),
            _vm.device?.userAgent?.device
              ? _c("div", { staticClass: "d-flex align-items-center" }, [
                  _vm._v("\n      Device:\n      "),
                  _vm.device.userAgent.device?.type
                    ? _c("i", {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            value: {
                              title: _vm.device.userAgent.device.type,
                              html: true,
                            },
                            expression:
                              "{ title: device.userAgent.device.type, html: true }",
                            modifiers: { hover: true },
                          },
                        ],
                        staticClass: "ml-2",
                        class: `far fa-fw fa-${_vm.deviceIcon}`,
                      })
                    : _vm._e(),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _c(
        "b-modal",
        {
          ref: "deviceModal",
          attrs: { size: "md", "hide-footer": true, "hide-header": true },
        },
        [
          _vm.device?.location
            ? _c(
                "div",
                { staticClass: "card card-img-top" },
                [
                  _c("google-map", {
                    attrs: {
                      width: "100%",
                      height: "300px",
                      markers: [
                        {
                          lat: _vm.device.location.latitude,
                          lng: _vm.device.location.longitude,
                        },
                      ],
                      zoom: 7,
                      search: false,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.device
            ? _c("div", { staticClass: "mt-3" }, [
                _vm.device?.location
                  ? _c("div", [
                      _c("h3", [
                        _vm._v(
                          _vm._s(_vm.device.location.city) +
                            ", " +
                            _vm._s(_vm.device.location.region)
                        ),
                      ]),
                      _c("div", { staticClass: "small" }, [
                        _vm._v(_vm._s(_vm.device.location.ip)),
                      ]),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "mt-2 mb-3" }, [
                  _c("div", { staticClass: "small" }, [_vm._v("Device")]),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("capitalize")(_vm.device.type)) +
                      "\n      "
                  ),
                ]),
                _vm.device?.userAgent
                  ? _c("div", { staticClass: "mt-3" }, [
                      _c("div", { staticClass: "small" }, [_vm._v("OS")]),
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("capitalize")(_vm.device.userAgent.os.name)
                          ) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
                _vm.device?.referrer
                  ? _c("div", { staticClass: "mt-3" }, [
                      _c("div", { staticClass: "small" }, [_vm._v("Referrer")]),
                      _c(
                        "a",
                        {
                          staticClass: "small",
                          attrs: {
                            target: "_blank",
                            href: _vm.device?.referrer,
                          },
                        },
                        [
                          _vm._v(_vm._s(_vm.device.referrer)),
                          _c("i", { staticClass: "ml-2 fa fa-external-link" }),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }